export default __webpack_public_path__ + "media/zurb/img/events/wired/family-giving/fg-1-a6ae426f424b450c0d0a439ec6fe4bd8.jpg";